(() => {
  const initTestimonials = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-domoxa-testimonials]')) roots.push(scope);
    roots.push(...(scope.querySelectorAll?.('[data-domoxa-testimonials]') || []));

    roots.forEach((root) => {
      if (root.dataset.testimonialsInitialized === 'true') return;
      root.dataset.testimonialsInitialized = 'true';

      const track = root.querySelector('[data-testimonials-track]');
      const prev = root.querySelector('[data-testimonials-prev]');
      const next = root.querySelector('[data-testimonials-next]');
      const toggle = root.querySelector('[data-testimonials-toggle]');
      const toggleLabel = toggle?.querySelector('[data-testimonials-toggle-label]');
      const dots = [...(root.querySelectorAll('[data-testimonials-dot]') || [])];
      if (!track) return;

      const cards = () => [...track.querySelectorAll('.domoxa-testimonials__card')];
      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

      const pageWidth = () => {
        const first = cards()[0];
        if (!first) return track.clientWidth;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '24') || 24;
        const cardsPerPage = isMobile() ? 1 : 2;
        return (first.offsetWidth + gap) * cardsPerPage;
      };

      const pageCount = () => isMobile()
        ? Math.max(1, cards().length)
        : Math.max(1, Math.ceil(cards().length / 2));

      const currentPage = () => {
        const width = pageWidth();
        if (!width) return 0;
        return Math.round(track.scrollLeft / width);
      };

      const setExpanded = (expanded) => {
        root.classList.toggle('is-expanded', expanded);
        if (toggle) {
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (toggleLabel) {
            toggleLabel.textContent = expanded
              ? toggle.dataset.showLessLabel || 'Voir moins de témoignages'
              : toggle.dataset.showMoreLabel || 'Voir plus de témoignages';
          }
        }
      };

      const syncMobileExtras = () => {
        if (!toggle) return;
        if (!isMobile()) {
          setExpanded(false);
        }
      };

      const syncUi = () => {
        syncMobileExtras();
        const page = currentPage();
        const maxPage = pageCount() - 1;
        if (prev) prev.disabled = page <= 0;
        if (next) next.disabled = page >= maxPage;
        dots.forEach((dot, index) => {
          const visible = index < pageCount();
          dot.hidden = !visible;
          const active = visible && index === page;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const goToPage = (page) => {
        const maxPage = pageCount() - 1;
        const target = Math.max(0, Math.min(page, maxPage));
        track.scrollTo({ left: target * pageWidth(), behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => goToPage(currentPage() - 1));
      next?.addEventListener('click', () => goToPage(currentPage() + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const page = Number(dot.dataset.page || 0);
          goToPage(page);
        });
      });

      toggle?.addEventListener('click', () => {
        if (!isMobile()) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        setExpanded(!expanded);
        if (expanded) {
          root.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });

      track.addEventListener('scroll', () => {
        window.clearTimeout(track._domoxaTestimonialsScrollTimer);
        track._domoxaTestimonialsScrollTimer = window.setTimeout(syncUi, 60);
      }, { passive: true });

      window.addEventListener('resize', syncUi, { passive: true });
      syncUi();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTestimonials(), { once: true });
  } else {
    initTestimonials();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTestimonials(event.target);
  });
})();
